module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"title":"Nos solutions en cours de développement","click_for_more":"Sélectionnez un produit pour en savoir plus"},"en":{"title":"Our solutions under development","click_for_more":"Select an item for details"}}')
  delete Component.options._Ctor
}
